var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");

var RoutingVertexData = require("./routingVertexData.js");
var PcbTerminalData = require("./pcbTerminal.js");

var RoutingSegmentData = function(startVertex, endVertex, net, width, layerIndex) {
    var self = this;

    this.makeObservableTreeNode();

    this.startVertex    = this.value("startVertex", false);
    this.endVertex      = this.value("endVertex", false);
    this.width          = this.value("width", true);
    this.layerIndex     = this.value("layerIndex", true);
    this.net            = this.value("net", false);

    this.startVertex.onChange("remove", function(value){
        if (value == null && self.isAlive())
            self.remove();   // remove segment if start or endvertex become undefined
    });
    this.endVertex.onChange("remove", function(value){
        if (value == null && self.isAlive())
            self.remove();   // remove segment if start or endvertex become undefined
    });

    this.segmentedGeometry = this.cachedFunction("segmentedGeometry",
        function(precision, layerIndex){
            if(layerIndex === this.layerIndex()) {
                if(self.startVertex() && self.endVertex()) {
                    return self.getSegment().toPolygon(self.width(), precision);
                }
            }

        },
        [[this.startVertex, this.startVertex.onBubble],
         [this.endVertex, this.endVertex.onBubble],
         this.width]
    );

    this.bufferedSegmentedGeometry = this.cachedFunction("bufferedSegmentedGeometry",
        function(precision, layerIndex, layerType, bufferSize){
            if(layerIndex === this.layerIndex()) {
                if(self.startVertex() && self.endVertex()) {
                    return self.getSegment().toPolygon(self.width()).buffer(bufferSize); // TODO
                }
            }

        },
        [[this.startVertex, this.startVertex.onBubble],
         [this.endVertex, this.endVertex.onBubble],
         this.width]
    );

    this.boundingBox = this.cachedFunction("boundingBox",
        function () { return self.segmentedGeometry(null, self.layerIndex()).getBB(); },
        [this.segmentedGeometry]
    );

    this.outlineGeometry = this.segmentedGeometry;


    this.onInit("init", this._initialize3d);


    if(startVertex !== undefined) this.startVertex(startVertex);
    if(endVertex !== undefined) this.endVertex(endVertex);
    if(net !== undefined) this.net(net);
    if(width !== undefined) this.width(width);
    if(layerIndex !== undefined) this.layerIndex(layerIndex);
    this.onAdd('vtxConSegMap', function() {
        // TODO: need this reference here because parent is undefined in the onBeforeDie
        this.vertexConnectedSegmentMap = this.parent().vtxConSegMap;
    });
};
lib_core.mixin(RoutingSegmentData, lib_core.ObservableTreeNode);
lib_core.JsonParser.registerClass(RoutingSegmentData, "RoutingSegmentData");

module.exports = RoutingSegmentData;

RoutingSegmentData.prototype._initialize3d = function(){
    var self = this;

    this.mesh = this.cachedFunction("mesh",
        function (precision){
            return this._getMesh(precision);
        },
        [this.outlineGeometry, this.layerIndex, this.parent().number_of_layers, this.parent().allHoles]
    );
}

RoutingSegmentData.prototype._getMesh = function(precision){
    var self = this;
    var geometry = this.outlineGeometry(precision);
   // var cutGeometry = lib_geometry.Union([geometry], this.parent().allHoles(precision));
    var holeGeoms = self.parent().getIntersectingHoles(this, precision);
    //console.log(holeGeoms);
    var cutGeoms = lib_geometry.Union([geometry], holeGeoms);

    var mesh = (new lib_geometry.TriangleMesh()).fromPolygon(cutGeoms, this.parent().copperThickness);
    if(mesh.isEmpty()) return mesh;
    var layer = self.parent().getRealLayer( self.layerIndex(), self.parent().number_of_layers());
    var myDeptPercent = layer / (self.parent().number_of_layers() - 1);
    var myDepth = (self.parent().boardThickness + self.parent().copperThickness) * myDeptPercent;
    mesh.translate(0, 0, myDepth);
    return mesh;
}


RoutingSegmentData.prototype.toString = function () {
    var result = "{";

    result += this.startVertex().toString() + ", ";
    result += this.endVertex().toString() + "}";

    return result;
};

RoutingSegmentData.prototype.move = function (vec) {
    if(this.startVertex().move)
        this.startVertex().move(vec);
    if(this.endVertex().move)
        this.endVertex().move(vec);
};

RoutingSegmentData.prototype.vec = function () {
    return this.endVertex().pos().sub(this.startVertex().pos());
};

RoutingSegmentData.prototype.length = function () {
    return this.vec().length();
};

RoutingSegmentData.prototype.center = function () {
    var start = this.startVertex().pos();
    var end   = this.endVertex().pos();
    return new lib_geometry.Coord((start.x+end.x)/2, (start.y+end.y)/2);
};

RoutingSegmentData.prototype.getLine = function() {
    return new lib_geometry.Line(this.vec(), this.startVertex().pos());
};

RoutingSegmentData.prototype.getSegment = function() {
    return new lib_geometry.Segment(this.startVertex().pos(), this.endVertex().pos());
};

/**
 * Returns an array containing both vertices.
 */
RoutingSegmentData.prototype.getVertices = function () {
    return [this.startVertex(), this.endVertex()];
};

RoutingSegmentData.prototype.hasVertex = function (vertex) {
    return this.getVertices().indexOf(vertex) > -1;
};

/**
 * Returns the vertex opposite to the vertex given.
 * @param vertex The vertex for which the other vertex is needed.
 */
RoutingSegmentData.prototype.otherVertex = function (vertex) {
    if(this.startVertex() === vertex) return this.endVertex();
    else if(this.endVertex() === vertex) return this.startVertex();
};

/**
 * Removes this segment and any incident non-shared vertices.
 */
RoutingSegmentData.prototype.removeSegment = function () {
    var self = this;
    var startVertex = this.startVertex();
    var endVertex = this.endVertex();

    lib_core.ObservableTreeNode.remove.call(this);

    var isVertexConnected = function (vertex) {
        var set = self.vertexConnectedSegmentMap.get(vertex);
        return set && set.size() > 0;
    };
    if (startVertex instanceof RoutingVertexData && !isVertexConnected(startVertex) )
        startVertex.remove();
    if (endVertex instanceof RoutingVertexData && !isVertexConnected(endVertex) )
        endVertex.remove();
};

/**
 * Removes this segment and any incident non-shared vertices (proxy for removeSegment).
 */
RoutingSegmentData.prototype.remove = RoutingSegmentData.prototype.removeSegment;

/**
 * Removes this segment and connects the two segments incident to this segment (if any)
 */
RoutingSegmentData.prototype.removeSegmentAndReconnectNet = function () {
    //get a pointer to the start and end vertex, before we remove them
    var startVertex = this.startVertex();
    var endVertex = this.endVertex();
    var self = this;

    //remove this segment
    this.removeSegment();

    if((startVertex instanceof RoutingVertexData) &&
        (endVertex instanceof RoutingVertexData)){
        //connect all segments connected to startVertex to endVertex
        //IF endVertex has RoutingSegments pointing to it.
        //TODO: come up with rules for more complex segment merges
        var endVertexHasSegments = endVertex.getConnectedSegments().size() > 0;
        if(endVertexHasSegments) {
            startVertex.getConnectedSegments().forEach(function (seg) {
                //disconnect segment from startVertex and attach to endVertex
                seg.swapVertices(startVertex, endVertex);
            });
            //TODO: Are there any trailing references to startVertex?
        }
    }
};

/**
 * Replaces the originalVertex with the newVertex in this segment.
 * @param originalVertex the vertex to swap out. This vertex will not be automatically removed by this method
 * @param newVertex the vertex that the segment should point to instead after the operation.
 * @return True if a vertex was swapped, False if no vertex was swapped
 */
RoutingSegmentData.prototype.swapVertices = function (originalVertex, newVertex) {
    var vertexToReplace;
    //TODO: is there a cleaner way to iterate over these vertices?
    if(this.startVertex() == originalVertex){
        vertexToReplace = this.startVertex;
    } else if (this.endVertex() == originalVertex){
        vertexToReplace = this.endVertex;
    }
    if(vertexToReplace){
        //disconnect the terminal (don't remove it) and replace it with a new vertex at the same location
        vertexToReplace(newVertex);
        return true;
    }
    return false;
};

/**
 * Disconnect this segment from a terminal if it's connected to it (startVertex or endVertex).
 * The terminal (if any) is replaced by a routingVertex.
 * @param terminal Terminal PcbTerminalData to disconnect from.
 */
RoutingSegmentData.prototype.disconnectTerminalFromSegment = function (terminal) {
    var vertexToReplace;
    //TODO: is there a cleaner way to iterate over these vertices?
    if(this.startVertex() == terminal){
        vertexToReplace = this.startVertex;
    } else if (this.endVertex() == terminal){
        vertexToReplace = this.endVertex;
    }
    if(vertexToReplace){
        //disconnect the terminal (don't remove it) and replace it with a new vertex at the same location
        vertexToReplace(new RoutingVertexData(terminal.pos(),this.net()));
        //add new vertex to pcb data model
        this.parent().routingVertices.add(vertexToReplace());
    }
};

/**
 * Splits the segment, creating a new segment at the endVertex.
 */
RoutingSegmentData.prototype.splitEnd = function() {
    // create new vertex
    var newVertex = new RoutingVertexData(this.endVertex().pos(), this.net());
    this.parent().routingVertices.add(newVertex);

    // create new segment
    var newSegment = new RoutingSegmentData(newVertex, this.endVertex(), this.net(), this.width(), this.layerIndex());
    this.parent().routingSegments.add(newSegment);
    this.endVertex(newVertex);

    return newSegment;
};

/**
 * Splits the segment, creating a new segment at the startVertex.
 */
RoutingSegmentData.prototype.splitStart = function() {
    // create new vertex
    var newVertex = new RoutingVertexData(this.startVertex().pos(), this.net());
    this.parent().routingVertices.add(newVertex);

    // create new segment
    var newSegment = new RoutingSegmentData(this.startVertex(), newVertex, this.net(), this.width(), this.layerIndex());
    this.parent().routingSegments.add(newSegment);
    this.startVertex(newVertex);

    return newSegment;
};

/**
 * Splits the segment at a given point.
 * @param point Point where the segment is going to be split.
 */
RoutingSegmentData.prototype.splitPoint = function(point) {
    // create new vertex
    var newVertex = new RoutingVertexData(point, this.net());
    this.parent().routingVertices.add(newVertex);

    // create new segment
    var newSegment = new RoutingSegmentData(newVertex, this.endVertex(), this.net(), this.width(), this.layerIndex());
    this.parent().routingSegments.add(newSegment);
    this.endVertex(newVertex);

    return newVertex;
};

RoutingSegmentData.prototype.splitVertex = function(vertex) {
    var newSegment = new RoutingSegmentData(vertex, this.endVertex(), this.net(), this.width(), this.layerIndex());
    this.parent().routingSegments.add(newSegment);
    this.endVertex(vertex);
};
/**
 * Get the shared vertices with another segment.
 * @param seg Segment for which to look for shared vertices.
 * @return sharedVertices Array containing the shared vertices.
 */
RoutingSegmentData.prototype.getSharedVertices = function(seg) {
    var sharedVertices = this.getVertices().filter(function(vertex){
       return seg.hasVertex(vertex);
    });
    return sharedVertices;
};

/**
 * Merges two segments that share at least one vertex.
 * @param seg Segment to merge.
 */
RoutingSegmentData.prototype.merge = function(seg) {
    var self = this;

    var sharedVertices = this.getSharedVertices(seg);
    if(seg.getSegment().length() > 0 && this.getSegment().contains(seg.getSegment())) {
        seg.getVertices().forEach(function (vertex) {
            if(!(sharedVertices.indexOf(vertex) > -1)) {
                switch (vertex.constructor) {
                    case RoutingVertexData:
                        if(vertex.getConnectedSegments().size() > 1)
                            self.splitVertex(vertex);
                        break;
                    default:
                        self.splitVertex(vertex);
                }
            }
        });
        seg.remove();
        return this;
    } else if(this.getSegment().length() > 0 && seg.getSegment().contains(this.getSegment())) {
        return seg.merge(this);
    } else {
        sharedVertices.forEach(function(sharedVertex) {
            if(sharedVertex.getConnectedSegments().size() === 2) {
                if(!(sharedVertex instanceof PcbTerminalData)) {
                    if(self.startVertex() === sharedVertex) {
                        self.startVertex(seg.otherVertex(sharedVertex));
                    } else if(self.endVertex() === sharedVertex) {
                        self.endVertex(seg.otherVertex(sharedVertex));
                    }
                    console.assert(self.getSegment().contains(sharedVertex.pos()));
                    sharedVertex.remove();
                    seg.remove();
                }
            }
        });
        return this;
    }
};

/**
 * Finds segments that are connected to this segment through a shared vertex.
 * If no vertex is specified, return the result for the start and end vertex.
 * @param vertex
 * @returns {Collections.HashSet|*}
 */
RoutingSegmentData.prototype.getConnectedSegments = function(vertex) {
    var self = this;
    var connectedSegments = new lib_core.Collections.HashSet();

    var addConnectedSegmentsAtVertex = function (vertex) {
        var vtxConSeg = self.vertexConnectedSegmentMap.get(vertex) || [];
        vtxConSeg.forEach(function (seg) {
            if(seg != self) connectedSegments.add(seg);
        });
    };

    if(vertex) addConnectedSegmentsAtVertex(vertex);
    else {
        this.getVertices().forEach(function (vertex) {
            addConnectedSegmentsAtVertex(vertex);
        });
    }

    return connectedSegments;
};

RoutingSegmentData.prototype.getLayers = function () {
    var layers = new lib_core.Collections.HashSet();
    layers.add(this.layerIndex());
    return layers;
};
